import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { applicationListConstants } from "./applicationList.constants";

const initialState = {
	loading: false,
	error: null,
	tab: "all",
	sort: {},
	filters: {},
	count: 0,
	page: 0,
};

export const getApplicationListState = state => state.applicationList;

const selector = property => fp.flow(getApplicationListState, fp.get(property));

// These selectors don't work because 'tab', 'page', 'sort', and 'filters' are not properties of the state,
// but they are used in the code. It can cause issues.
export const getApplicationListTab = selector("tab");
export const getPage = selector("page");
export const getSort = selector("sort");
export const getFilters = selector("filters");

function applicationList(state = initialState, action) {
	switch (action.type) {
		case applicationListConstants.UPDATE_APPLICATION_STATUS: {
			return {
				...state,
				applications: [...action.updatedApplications],
			};
		}
		default:
			return state;
	}
}

export default withResetState({ initialState })(applicationList);
